'use strict';

/* @ngInject */
class Trans {
    constructor($scope, $http, toastr) {
        this.$scope = $scope;
        this.$http = $http;
        this.toastr = toastr;
        this.items = [];
        this.un = false;

        $scope.orderitems = (item)=>{
            return parseInt(item.num);
        };
        $scope.filterFunction = (item)=>{
            if(!this.un) return true;
            if(parseInt(item.check)) return true;
            if(!item.ru) return true;
            return false;
        };
    }

    add(num)
    {
        this.items.push({id:0,en:"",ru:"",num:parseInt(num)+1});
    }

    delete(item)
    {
        this.$http({
            url: "/api/transdelete",
            method: "post",
            data: $.param({'id':item.id}),
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
        }).then(
            (resp)=>{
                let payload = resp.data;
                if(payload.code!=200)
                    this.toastr.error(payload.message);
                else
                {
                    this.totalinfo = this.total();
                    this.toastr.success(payload.message);

                    for(let i = 0; i<this.items.length; i++)
                        if(this.items[i].id === item.id) {
                            this.items.splice(i, 1);
                            break;
                    }
                }
            }
        )
    }

    get()
    {
        this.$http({
            url: "/api/gettrans",
            method: "get",
        }).then(
            (resp)=> {
                console.log(resp.data);
                this.items = resp.data;
                this.totalinfo = this.total();
            }
        )
    }

    total()
    {
        let count = 0;
        let num = 0;
        this.items.forEach((item)=>{
            if (item.ru && !parseInt(item.check)) num++;
            if (item.en) count++;
        });
        return num + " / " + count + " = " + Math.floor(num*100/count) + "%";
    }

    save(item)
    {
        this.$http({
            url: "/api/savetrans",
            method: "post",
            data: $.param({'id':item.id, 'en':item.en, 'ru': item.ru, 'num': item.num}),
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
        }).then(
            (resp)=>{
                let payload = resp.data;
                if(payload.code!=200)
                    this.toastr.error(payload.message);
                else
                {
                    this.totalinfo = this.total();
                    item.saved = true;
                    this.toastr.success(payload.message);
                }
            }
        )
    }
}

Trans.$inject = ['$scope', '$http', 'toastr'];
export {Trans};